export default __webpack_public_path__ + "static/media/Wolves.ce5d1caa.png";